import { useContext } from "react"

import { AuthContext } from "./context"

const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within the AuthProvider");
  } else {
    return context;
  }
};

export default useAuthContext;
